export const ActionTypes = {
  ShowLoader: '[App] Show Loader',
  SetUserInfo: '[App] Set User Info',
  SetActivePage: '[App] Set Active Page',
  SetDefaultContactSupport: '[APP] Set default contact support',
};
